import React, { Component } from 'react';

class Icon extends Component {
	constructor(props) {
		super(props);

		this.state = {
			// activeGraphic: ''
		};
	}

	componentDidMount = () => {
		// nothing
	}

	icon = () => {
		let viewbox = '0 0 1200 1200';
		let style = {
			width: '100%',
			height: '100%',
			enablebackground: 'new 0 0 1200 1200'
		}
		if (this.props.fill) {
			style = {
				...style,
				fill: this.props.fill
			}
		}
		let color2 = {
			fill: this.props.fill2
		}

		let svgInner = '';
		let yahCircles = (
			<>
				<circle style={color2} cx="600" cy="600" r="312.6"/>
				<circle cx="600" cy="600" r="266.3"/>
			</>
		)
		let yahText = (
			<g style={color2}>
				<path d="M494.8,467.1l23.2-44.8h17.5l-32.7,60.2v38.1h-16.1V483l-32.5-60.7h17.5L494.8,467.1z"/>
				<path d="M635.7,471.3c0,16-4,28.4-12,37.3s-19.3,13.3-33.9,13.3c-14.8,0-26.2-4.4-34.2-13.2
					c-8-8.8-11.9-21.3-11.9-37.6s4-28.7,12-37.4c8-8.7,19.4-13.1,34.2-13.1c14.6,0,25.9,4.4,33.8,13.3
					C631.7,442.8,635.7,455.3,635.7,471.3z M560.7,471.3c0,12.1,2.5,21.2,7.3,27.5c4.9,6.3,12.1,9.3,21.7,9.3c9.5,0,16.7-3,21.6-9.2
					c4.9-6.2,7.3-15.4,7.3-27.6c0-12.1-2.5-21.2-7.2-27.4c-4.8-6.2-12-9.3-21.5-9.3c-9.6,0-16.9,3.1-21.8,9.3
					C563.1,450.1,560.7,459.2,560.7,471.3z"/>
				<path d="M733.8,422.3v63.6c0,7.3-1.6,13.6-4.7,19.1c-3.1,5.4-7.6,9.6-13.5,12.6s-13,4.4-21.1,4.4
					c-12.2,0-21.6-3.2-28.4-9.6c-6.8-6.5-10.1-15.3-10.1-26.6v-63.3h16.1v62.1c0,8.1,1.9,14.1,5.6,17.9c3.7,3.8,9.5,5.8,17.3,5.8
					c15.1,0,22.7-8,22.7-23.9v-62L733.8,422.3L733.8,422.3z"/>
				<path d="M546,640.5l-9.8-27.3h-37.6l-9.6,27.3h-16.9l36.8-98.6h17.5l36.8,98.6H546z M532,599.3l-9.2-26.7
					c-0.7-1.8-1.6-4.6-2.8-8.5c-1.2-3.8-2-6.7-2.5-8.5c-1.2,5.5-2.9,11.5-5.3,18.1l-8.8,25.6L532,599.3L532,599.3z"/>
				<path d="M592.1,601.2v39.2h-16v-98.2h27.7c12.7,0,22,2.4,28.1,7.1c6.1,4.7,9.1,11.9,9.1,21.5
					c0,12.2-6.4,20.9-19.1,26.1l27.7,43.5h-18.3L608,601.2H592.1z M592.1,587.9h11.1c7.5,0,12.9-1.4,16.2-4.1c3.3-2.8,5-6.9,5-12.4
					s-1.8-9.5-5.4-12c-3.6-2.5-9.1-3.6-16.4-3.6h-10.5V587.9z"/>
				<path d="M719.6,640.5h-55.5v-98.2h55.5v13.5h-39.5v26.7h37.1V596h-37.1v30.9h39.5V640.5z"/>
				<path d="M518,760.4h-16.1v-44.2h-45.3v44.2h-16v-98.2h16v40.2h45.3v-40.2H518V760.4z"/>
				<path d="M599.4,760.4h-55.5v-98.2h55.5v13.5h-39.5v26.7H597v13.5h-37.1v30.9h39.5V760.4z"/>
				<path d="M636.8,721.1v39.2h-16.1v-98.2h27.7c12.7,0,22,2.4,28.1,7.1c6.1,4.7,9.1,11.9,9.1,21.5
					c0,12.2-6.4,20.9-19.1,26.1l27.7,43.5H676l-23.5-39.2H636.8z M636.8,707.8h11.1c7.5,0,12.9-1.4,16.2-4.1c3.3-2.8,5-6.9,5-12.4
					c0-5.6-1.8-9.5-5.4-12c-3.6-2.5-9.1-3.6-16.4-3.6h-10.6L636.8,707.8L636.8,707.8z"/>
				<path d="M764.2,760.4h-55.5v-98.2h55.5v13.5h-39.5v26.7h37.1v13.5h-37.1v30.9h39.5V760.4z"/>
			</g>
		)

		switch (this.props.value) {
			case 'ada': {
				svgInner = (
					<g>
						<path d="M937,547.4c-11.7-12.1-28.1-18.3-44.7-17.5l-202.5,11.2l111.5-126.8c15.9-18,20.4-42.1,14.3-63.8
							c-3.3-14.7-12.2-28.1-25.9-36.7c-0.7-0.2-266.5-154.6-266.5-154.6c-21.7-12.6-49.1-9.8-67.8,6.8l-130,116
							c-23.9,21.3-26,58-4.7,81.9s58,26,81.9,4.7l98.5-87.9l81.4,47.4L439,491.6c-59.6,9.8-113.2,37.2-155.3,76.7l75,75
							c33.9-30.9,79-49.6,128.2-49.6c105.2,0,191,85.6,191,191c0,49.3-18.9,94.4-49.6,128.2l75,75c50-53.1,80.7-124.6,80.7-203.4
							c0-46.8-10.8-91.2-30.2-130.7l78.5-4.4l-19,233.8c-2.6,32,21.1,59.9,53.1,62.6c1.6,0.2,3.1,0.2,4.7,0.2c29.9,0,55.4-23.1,57.8-53.3
							l24.5-300.2C954.6,576,948.7,559.4,937,547.4z"/>
						<path d="M829.3,298.7c53.6,0,97.1-43.5,97.1-97.1s-43.5-97.1-97.1-97.1s-97.1,43.5-97.1,97.1S775.7,298.7,829.3,298.7z
							"/>
						<path d="M487.1,975.6c-105.4,0-191-85.6-191-191c0-39.7,12.2-76.5,33-107.1l-75.8-75.8
							c-39.5,50.5-63.1,113.9-63.1,182.9c0,164.1,133,297,297,297c69,0,132.4-23.6,182.9-63.1l-75.8-75.8
							C563.6,963.4,526.7,975.6,487.1,975.6z"/>
					</g>
				) 
				break;
			}
			case 'atm': {
				svgInner = (
					<g>
						<path d="M842.4,291.8H357.6c-19.2,0-34.6,15.5-34.6,34.6v727c0,19.2,15.5,34.6,34.6,34.6h484.8
							c19.2,0,34.6-15.5,34.6-34.6v-727C877,307.4,861.5,291.8,842.4,291.8L842.4,291.8z M530.7,970.5c0,7.7-6.2,13.8-13.8,13.8h-76.2
							c-7.7,0-13.8-6.2-13.8-13.8V859.7c0-7.7,6.2-13.8,13.8-13.8h76.2c7.6,0,13.8,6.1,13.8,13.8V970.5z M773.1,1018.9H669.3V361.1h103.9
							V1018.9z"/>
						<path d="M1043.2,111.8H156.8c-7.7,0-13.8,6.2-13.8,13.8v332.4c0,7.7,6.2,13.8,13.8,13.8h138.5V361.1h-41.6V222.6h692.5
							v138.5h-41.6v110.7h138.5c7.7,0,13.8-6.2,13.8-13.8V125.6C1057,118,1050.9,111.8,1043.2,111.8L1043.2,111.8z"/>
					</g>
				) 
				break;
			}
			case 'coffee': {
				svgInner = (
					<path d="M605,318.7c-31,21.4-50.6,61.6-38.6,98.7l0,0c6.8,19.9,23.1,38.4,44,43.7l0,0c20.6,3,14.8-21.7,18-34.2l0,0
						c1.5-8.5,6.3-15.8,14.2-19.2c76.8-29,116.6-121.9,41.3-176.3c-37.6-21.4-12.4,62.7-67.3,80C613.2,313.4,608.8,317,605,318.7z
						M612,149.6c17.2,74.3-38.4,130.2-95,168c-17.5,14.9-14.1,42.8-12.6,63.5l0,0c1.6,13.8-13,18.1-23.9,14.5l0,0
						c-61-15.7-84.7-90.4-58.6-144.1c15.4-38.9,54-59.8,79.5-90.7c30.3-32.9-1.5-118.4,44.3-95.6l0,0C579.8,80.5,603.9,113.7,612,149.6z
						M1027.4,694.2c7.8-31.4,5.9-64.3-5.5-94.5c-11.4-30.2-31.7-56.3-58.3-74.6c-26.5-18.4-58.1-28.2-90.4-28.2H233.6
						c-11.4,0-22.4,4.7-30.3,13c-7.9,8.3-12,19.5-11.4,31c5,76.2,18.1,151.7,38.9,225.1c15.7,55.1,46.5,104.7,89.1,143.1h-55
						c-16.6,0-31.9,8.8-40.1,23.2c-8.3,14.4-8.3,32.1,0,46.4c8.3,14.4,23.6,23.2,40.1,23.2h521.6c16.6,0,31.9-8.8,40.1-23.2
						c8.3-14.4,8.3-32,0-46.4s-23.6-23.2-40.1-23.2h-55.1c29.5-26.6,53.4-58.6,70.6-94.4h71.2c35.5,0,69.9-11.9,97.9-33.7
						C999,759.2,1018.9,728.6,1027.4,694.2L1027.4,694.2z M934,671c-3.3,13.7-11.1,25.8-22.1,34.5c-11,8.7-24.7,13.4-38.7,13.4h-40.6
						c9.8-41.3,17.2-83.2,22.2-125.3h18.4c19.3,0,37.5,8.8,49.4,24.1c11.9,15.2,16.1,35,11.4,53.7V671z"/>
				) 
				break;
			}
			case 'dollarSign': {
				svgInner = (
					<g>
						<path d="M525,75h150v182.6H525V75z"/>
						<path d="M525,942.4h150V1125H525V942.4z"/>
						<path d="M600,1012.5c-141.5,0-256.6-106-256.6-236.4h150c0,47.7,47.8,86.4,106.6,86.4s106.6-38.7,106.6-86.4
							c0-40.3-20.5-68.4-59.3-81.3l-142-47.2C405.4,614.2,343.4,528.5,343.4,424c0-130.4,115.1-236.4,256.6-236.4s256.6,106,256.6,236.4
							h-150c0-47.7-47.8-86.4-106.6-86.4S493.4,376.3,493.4,424c0,40.3,20.5,68.4,59.3,81.3l142,47.2c99.9,33.4,161.8,119.1,161.8,223.7
							C856.6,906.4,741.4,1012.5,600,1012.5z"/>
					</g>
				) 
				break;
			}
			case 'elevator': {
				svgInner = (
					<g>
						<path d="M571.8,884.1H316.2c-31,0-56.4-21.2-56.4-47.1V363.2c0-25.9,25.4-47.1,56.4-47.1h255.6L571.8,884.1L571.8,884.1
							z M883.8,316.1H628.2v566.8h255.6c31,0,56.4-21.2,56.4-47.1V363.2C940.2,337.3,914.8,316.1,883.8,316.1z"/>
						<path d="M484,952.9c-8.5,0-17.1,3.4-23.9,10.2c-13.6,13.6-13.6,34.1,0,47.8l116,156c13.6,13.6,35.8,13.6,47.8,0l116-156
							c13.6-13.6,13.6-34.1,0-47.8c-6.8-6.8-12.8-10.2-23.9-10.2C657.1,952.9,492.6,952.9,484,952.9z"/>
						<path d="M715.3,245.6c8.5,0,17.1-3.4,23.9-10.2c13.6-13.6,13.6-34.1,0-47.8l-116-156c-13.6-13.6-35.8-13.6-47.8,0
							l-116,156c-13.6,13.6-13.6,34.1,0,47.8c6.8,6.8,12.8,10.2,23.9,10.2C542.2,245.6,706.8,245.6,715.3,245.6z"/>
					</g>
				) 
				break;
			}
			case 'escalator': {
				svgInner = (
					<g>
						<path d="M974.8,319.7H763.4c-8.4,0-16.4,3.3-22.4,9.3L291.1,778.9c-6,6-13.9,9.3-22.4,9.3h-43.6
							c-142.2,4.8-142.7,210.4,0,215.2h132.3c8.4,0,16.4-3.3,22.4-9.3l446.5-446.5c6-6,13.9-9.3,22.4-9.3h126.1
							C1117.5,533.9,1117.9,324.2,974.8,319.7L974.8,319.7z"/>
						<path d="M504.4,353.1c103.4-3.3,103.4-153.3,0-156.6C400.9,199.9,401,349.9,504.4,353.1z"/>
						<path d="M587.6,416.4c0-28.5-23.2-51.8-51.8-51.8h-62.9c-28.5,0-51.8,23.2-51.8,51.8v175.5l166.3-166.3L587.6,416.4z" />
					</g>
				) 
				break;
			}
			case 'food': {
				svgInner = (
					<g>
						<path d="M478.3,112.5c-8.4,1.7-15.9,6.3-21.3,13c-5.3,6.7-8.1,15.1-7.9,23.7v235.2c0,9.4-3.7,18.2-10.3,24.9
							c-6.5,6.5-15.5,10.3-24.9,10.3c-9.4,0-18.2-3.7-24.9-10.3c-6.5-6.5-10.3-15.5-10.3-24.9V149.1c0.2-8.6-2.6-16.9-7.9-23.7
							c-5.3-6.7-12.9-11.3-21.3-13c-10.2-1.8-20.7,1.1-28.6,7.8c-7.9,6.6-12.4,16.6-12.4,26.8v235.3c0.2,8.6-2.6,16.9-7.9,23.7
							c-5.3,6.7-12.9,11.3-21.3,13c-10.2,1.7-20.7-1.1-28.5-7.8c-7.9-6.6-12.4-16.5-12.5-26.7V149.1c0.2-8.6-2.6-16.9-7.9-23.7
							c-5.3-6.7-12.9-11.3-21.3-13c-10.2-1.8-20.7,1.1-28.6,7.9c-7.9,6.7-12.4,16.6-12.4,26.9v323.5c0,26.9,10.8,52.8,29.7,71.9
							c19.1,19.1,44.9,29.7,71.9,29.7c6.5,0,12.5,2.6,17,7.3c4.4,4.7,6.7,10.9,6.4,17.3l-22.2,409.6c-1.5,20,5,39.7,18,55
							c13,15.2,31.6,24.7,51.5,26.3c20.7,0.9,40.7-6.9,55.2-21.6c14.5-14.7,22.2-34.8,21-55.5L394.1,597l0,0c-0.4-6.4,2-12.7,6.4-17.3
							c4.4-4.7,10.6-7.3,16.9-7.3c26.9,0,52.8-10.8,71.9-29.7c19.1-19.1,29.7-44.9,29.7-71.9V147.2c0-10.4-4.6-20.2-12.4-26.8
							C499,113.8,488.5,110.9,478.3,112.5L478.3,112.5z"/>
						<path d="M1032,366.7c0-128.9-80.3-254.5-179.2-254.5S673.7,237.7,673.7,366.7c0,97,45.5,168,110.2,197.2l0,0
							c5.8,2.6,10.6,6.9,13.8,12.2c3.3,5.4,4.9,11.7,4.5,18l-22.3,412.6c-1.5,20,5,39.7,18,55c13,15.2,31.6,24.7,51.5,26.3
							c20.7,0.9,40.7-6.9,55.2-21.6c14.5-14.7,22.2-34.8,21-55.5l-22.4-416.8c-0.4-6.3,1.2-12.5,4.5-18s8.1-9.6,13.8-12.2
							C986.5,534.7,1032,463.7,1032,366.7L1032,366.7z"/>
					</g>
				) 
				break;
			}
			case 'gift': {
				svgInner = (
					<path d="M350.7,127c-83.2,0-121.4,96.3-83.2,168c15.2,23.7,33.1,38.2,54.7,47.5H216.7h-8.5c-42,3-63.2,27.1-63.2,72.9
						v118.8h335.1V414.6h239.7v119.6H1055V414.6c0-48.4-23.7-72.1-71.2-72.1h-106c21.6-9.3,39.4-23.7,54.7-47.5c38.2-71.7,0-168-83.2-168
						c-70,0-165.8,66.6-211.3,143.8h-76C516.7,193.5,420.8,127,350.7,127L350.7,127z M204.8,558v443.4c0,47.9,24.2,71.7,71.2,71.7h204.1
						v-515L204.8,558z M719.8,558v515h202.8c48.8,0,72.5-24.2,72.5-72.5V558H719.8z"/>
				) 
				break;
			}
			case 'info':
				svgInner = (
					<g>
						<path d="M601.4,1125L601.4,1125c-73.7,0-133.5-59.8-133.5-133.5V589.9c0-73.7,59.8-133.5,133.5-133.5l0,0
							c73.7,0,133.5,59.8,133.5,133.5v401.6C734.9,1065.2,675.1,1125,601.4,1125z"/>
						<circle cx="601.4" cy="190.6" r="133.5"/>
					</g>
				)
				break;
			case 'mens': {
				svgInner = (
					<path d="M562.6,683.8v393.5c0,14.9-4.8,28.4-16.3,38.2c-14.8,12.6-35.8,14.6-52.8,5.2c-15.5-8.4-25.7-25.8-25.7-43.4
						V397.1h-15.2v253.3c0,10.9-5.7,21.6-14.2,28.3c-12.4,9.8-28.2,10.8-41.5,2.1c-11.4-7.4-17.7-20.1-17.7-33.5V366.7
						c0-25.6,10.3-51.3,27.5-70.3c16.4-18.1,45.2-36.5,70.3-36.5h188.9c30.9,0,66.9,19.5,85.6,42.6c16.1,20,24.6,47.9,24.6,73.1v271.5
						c0,11.9-11,25.9-21.5,30.8c-10.8,5-24.1,4.6-34.3-1.4c-11.5-6.8-17.6-19.3-17.6-32.4v-247H685v686.6c0,13.5-10.3,26.6-21,33.9
						c-15,10.3-35.8,12.1-52,3.3c-13.1-7.2-24.8-21.7-24.8-37.2V683.8H562.6z M575.7,238.6c-30.5,0.8-61.5-18.8-78-43.3
						c-25.9-38.4-21.3-88.1,11.5-120.9c32.4-32.3,83.4-36.7,121.3-11.4c37.9,25.2,53.3,73.2,35.2,115.1
						C650.3,214.2,615,237.6,575.7,238.6L575.7,238.6z"/>
				) 
				break;
			}
			case 'north': {
				svgInner = (
					<path d="M1135.8,565.3c0.5-4.3-0.4-10.3-6-10.2c0,0-78.3,0-78.3,0c-3.5-68.1-24.6-138.5-58.6-197.5
						c-0.1-0.2-15.1-24.3-15.2-24.5c-0.1-0.5-16.7-23.3-17-23.8c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-18.5-22.4-18.8-22.3
						c0-0.2-19.6-21-19.7-21.2c0-0.1-0.1-0.1-0.2-0.1c-0.2-0.4-20.9-19.7-21.3-19.9c0,0-0.1-0.1-0.1-0.2c-0.4-0.3-22.1-18.2-22.5-18.4
						l-23.3-16.7c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1L830,194.9c-57.3-33-125.4-53.7-191.5-58.3c-0.7-1.7-25-96.7-26-98.2
						c-1-2.1-3.2-3.1-5.4-3.3c-2.5,0.1-4.9,1.8-5.6,4.3c-0.4,0.2-25.5,97-25.7,97.4c-14.1,1-41.7,4.5-55.5,7.4
						c-55.7,10.9-112.7,34.5-159.9,65.9c-0.3,0.1-23.3,16.7-23.6,16.9c-0.1,0-0.1,0.1-0.2,0.1l-22.2,18.2c-0.1,0-0.1,0.1-0.1,0.2
						c0,0-0.1,0.1-0.2,0.1l-21,19.6c-0.1,0-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.2,0.1l-19.6,21c0,0,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.2,0.1
						L254.7,309c0,0.1-0.1,0.3-0.2,0.3l-16.7,23.3c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2l-15.2,24.3c0,0.1,0,0.1-0.1,0.2
						c-33.8,59.2-55.2,129.4-58.6,197.6H85.6c-3.3,0-6,2.7-6,6c-0.5,4.3,0.4,10.3,6,10.2c0,0,77.8,0,77.8,0c-0.9,18.7,1.1,48.3,3.5,66.8
						c0,0.5,4.6,28.3,4.8,28.7c8.7,46,27.3,95.2,50.7,135.7v0.1l15.2,24.4c0,0.1,0.1,0.1,0.2,0.2v0.1c0.1,0.1,16.7,23.3,16.8,23.4
						c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,18.2,22.2,18.3,22.3c0,0.1,0.1,0.1,0.1,0.2c0.2,0.1,19.5,21.1,19.8,21.1c0,0,0.1,0.1,0.1,0.2
						l21,19.6c0.1,0.1,0.3,0.1,0.3,0.3c0.2,0.1,22.2,18.3,22.4,18.3c0,0.1,23.3,16.8,23.4,16.9c0.1,0,0.1,0.1,0.2,0.1l0.1,0.1l1.7,1.1
						c0,0.7-53.5,202-53.1,202.7c-0.6,3,1.6,5.6,4.3,6.5c2.1,0.6,4.3-0.2,5.8-1.6c0.9-0.9,154-154,154.7-154.7
						c31.7,10.4,71.3,17.2,104.6,19.6c14.5,0.9,43.3,0.9,57.8,0c26-1.7,60.8-7.4,86-14c0.3,0,18.2-5.5,18.6-5.6
						c0,0,154.7,154.5,154.7,154.5c1.6,1.3,4.1,2.5,6.1,1.4c2.6-0.8,4.6-3.5,4-6.3c0.4-0.7-53.1-202-53.1-202.7l1.7-1.1
						c0.1,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,23.3-16.8,23.4-16.9c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,22.2-18.2,22.3-18.3
						c0-0.1,0.1-0.1,0.2-0.1l21-19.6c0.1,0,0.1-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1l19.6-21c0-0.1,0.1-0.1,0.1-0.2
						c0.1,0,18.2-22.2,18.3-22.3c0-0.1,0.1-0.1,0.1-0.2c0.1,0,16.7-23.3,16.8-23.4c0,0,0-0.1,0.1-0.1c0.3-0.1,15.1-24.4,15.3-24.6
						c0,0,0-0.1,0.1-0.2c18.2-31.9,34.9-72,44.3-107.5c3.8-14.3,9.3-42.5,11.4-57.1c2.1-18.6,4.4-48,3.5-66.6h77.8
						C1133.1,571.3,1135.8,568.6,1135.8,565.3L1135.8,565.3z M196.7,553C209,353.9,368.5,188.6,567.3,170.5l-101,384.7H196.6L196.7,553z
						M356.9,906.7C254.6,828.8,192.1,700,196.1,571.3h266L371.3,917L356.9,906.7z M468.2,993l-141.6,141.6l47.7-181.7l0,0l101.4-386l0,0
						l1.1-4.2l0,0L580.5,168l0,0l3.5-13.3l0,0l0.1-0.2l0,0c1.6-6,15.6-59.6,17.6-67v772.1L468.2,993z M714.2,977.8
						c-68.9,18.4-145,18.2-213.9-0.1l107.1-107.1l107.1,107.1L714.2,977.8z M647.8,170.4c200.2,18.3,359,184.6,370.8,384.9H748.8
						L647.8,170.4z M1018.5,607c-7.8,122.2-73.6,240.4-174.6,310l-90.8-345.7h266C1019.7,577.1,1018.7,600.8,1018.5,607z"/>
				) 
				break;
			}
			case 'parking': {
				svgInner = (
					<path d="M942.8,439.9c0,91.8-28.7,161.9-86,210.5c-57.3,48.6-138.8,72.9-244.5,72.9h-77.5V1027H354V174h272.2
						c103.4,0,182,22.3,235.8,66.8C915.9,285.3,942.8,351.7,942.8,439.9z M534.9,575h59.4c55.5,0,97-11,124.6-32.9s41.4-53.9,41.4-95.8
						c0-42.3-11.5-73.5-34.6-93.7c-23.1-20.2-59.3-30.3-108.6-30.3h-82.1V575z"/>
				) 
				break;
			}
			case 'restrooms': {
				svgInner = (
					<g>
						<path  d="M234.6,757.3v24c0,65.6-0.1,131.2,0,196.8c0,14.8-0.1,29.5,1.3,44.1c2.1,21,13.2,31.6,31.7,31.8
							c19,0.4,27.4-9.2,30.6-30c2-12.4,3.2-25.2,3.2-37.9c0.4-68.9,0.1-137.9,0.3-206.8c0-5.4-0.4-10.8,0.8-16c0.4-2.4,7.4-5.9,9.2-5.6
							c0.1,0,0.4,0,0.4,0.1c0.1,0,0.4-0.1,0.4-0.1c1.8-0.4,8.7,3.3,9.2,5.6c1.2,5.1,0.8,10.6,0.8,16c0,68.9-0.1,137.9,0.3,206.8
							c0.1,12.7,1.3,25.4,3.2,37.9c3.2,20.7,11.7,30.3,30.6,30c18.4-0.4,29.6-10.7,31.7-31.8c1.5-14.7,1.3-29.3,1.3-44.1
							c0.1-65.6,0-131.2,0-196.8v-24h41.1c24.2,0,41.7-23,35.2-46.2c-26.7-96.7-52.8-191.4-79.1-286.7c-1.6-5.9,2.6-12.1,8.8-12.3
							c7-0.3,9.1,7.3,11.3,14.4c16.4,54.3,32.4,108.8,48.7,163.1c3,10.2,4.9,22.5,11.9,29.2c7.4,7.2,21,13.9,30.1,11.9
							c8-1.6,15.7-14.5,19.3-24c2.6-7.1-0.4-17.2-2.9-25.4c-19.1-65.4-38.2-130.7-58.1-195.7c-15.3-49.8-50.6-74.9-103.4-74.9h-40.4
							h-40.4c-52.8,0.1-88.2,25-103.4,74.9c-20.1,65-39.2,130.3-58.3,195.6c-2.4,8.2-5.6,18.2-2.9,25.4c3.6,9.5,11.3,22.4,19.3,24
							c9.1,1.8,22.7-4.7,30.1-11.9c6.9-6.7,8.8-19.1,11.9-29.2c16.4-54.3,32.4-108.8,48.7-163.1c2.1-7.1,4.4-14.7,11.3-14.4
							c6.2,0.3,10.4,6.4,8.8,12.3c-26.3,95.3-52.3,190-79.1,286.7c-6.4,23.3,11.1,46.2,35.2,46.2L234.6,757.3z"/>
						<path  d="M382.9,201.9c9.2,39.1-14.9,78.2-54,87.4c-39.1,9.2-78.2-14.9-87.4-54s14.9-78.2,54-87.4
							C334.5,138.6,373.7,162.8,382.9,201.9"/>
						<path  d="M1006.3,311.8c-29-2.6-58.4-4.2-87.7-4.5c-29.3,0.3-58.8,1.8-87.7,4.5c-58,5.3-87.4,43.1-87.4,100.9
							c-0.1,71.9-0.1,143.7,0.1,215.5c0.1,27.9,8.7,39.1,28.8,40.1c23.8,1.3,36-10,36.2-35c0.4-58.4,0.1-116.8,0.3-175.3v-14.5
							c0-6.3,5.6-11.2,11.8-10c5.6,1,7.1,6.4,7,14.7c-0.4,39.6-0.1,79.2-0.1,118.9c0,143.7,0,287.4,0.1,431.1c0,7.3-0.1,14.9,1.6,21.9
							c4.9,20.7,20.2,33.5,39.5,34.1c20.1,0.7,33.6-11.8,39-33.4c2.1-8.3,2.5-17.3,2.5-25.9c0.1-100.8,0-201.4,0-302.2v-18.1
							c0-3.4,5.1-6.4,8.4-7.4c3.2,1,8.4,4.1,8.4,7.4v18.1c0,100.6-0.1,201.4,0,302.2c0,8.7,0.4,17.6,2.5,25.9c5.6,21.6,18.9,34.1,39,33.4
							c19.3-0.7,34.6-13.3,39.5-34.1c1.7-7.1,1.6-14.7,1.6-21.9c0.1-143.7,0.1-287.4,0.1-431.1c0-39.6,0.3-79.2-0.1-118.9
							c-0.1-8.2,1.3-13.6,7-14.7c6.2-1.2,11.8,3.8,11.8,10v14.7c0,58.4-0.3,116.9,0.3,175.3c0.1,24.9,12.3,36.1,36.2,35
							c20.1-1,28.7-12.3,28.8-40.1c0.4-71.9,0.3-143.7,0.1-215.5C1093.7,354.9,1064.2,317.1,1006.3,311.8L1006.3,311.8z"/>
						<path  d="M990.4,217.8c0,39.7-32.2,71.9-71.9,71.9c-39.7,0-71.9-32.2-71.9-71.9s32.2-71.9,71.9-71.9
							C958.2,145.9,990.4,178.1,990.4,217.8"/>
						<path  d="M624.2,117.9c-10,0-18.2,7.8-18.2,17.3v929.7c0,9.6,8.1,17.3,18.2,17.3s18.2-7.8,18.2-17.3V135.1
							C642.4,125.7,634.3,117.9,624.2,117.9L624.2,117.9z"/>
					</g>
				) 
				break;
			}
			case 'stairs': {
				svgInner = (
					<path d="M144,412h216v296h216v296h432V788H792V492H576V196H144V412z"/>
				) 
				break;
			}
			case 'womens': {
				svgInner = (
					<path d="M391,766.2l118.4-401.5h-18.8l-74.8,239.7c-3.7,11.8-17.6,20.6-29,23.2c-14.5,3.2-28.2-2.3-36.8-14.2
						c-7.2-10.1-9.7-25.3-5.9-37l87.3-270.6c3.2-9.9,7.6-20,14.6-27.9c10.2-11.6,23.4-21.6,37-28.8c8.8-4.8,19.5-8.7,29.5-8.7h168.4
						c22.7,0,45.4,6.1,62.5,21.7c11.8,10.8,24.1,28.4,28.1,43.7l71.7,270.6c3.1,11.8,0.2,24.6-7.8,33.9c-10.6,12.3-26.1,16.8-41.4,11.1
						c-10.4-3.8-19.5-12.4-22.5-23.2l-65.6-233.4h-18.6l109.1,401.5H680.8v323.6c0,10.7-8.2,20.5-16,26.6c-11.8,9.1-27.7,10.4-40.9,3.2
						c-13.4-7.2-24.2-23.8-24.2-39.1V763.1h-21.8v323.7c0,11.7-5.2,21.9-14.7,29c-14.5,10.5-33.7,10.8-48.7,0.9
						c-11.3-7.4-17.7-19.6-17.7-32.9V766.2H391z M588.9,218.5c-28.9,0.9-57.6-16.4-73.2-40c-22.5-34-17.2-81,11.9-109.5
						c28.4-28,75.4-33,109-11.1c34.6,22.6,49.2,67.8,33.3,106C656.2,196.7,624.2,217.4,588.9,218.5L588.9,218.5z"/>
				) 
				break;
			}
			case 'you_are_here_0': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="600,20 489.4,321.2 710.6,321.2 "/>
						<polygon points="600,136 489.4,437.2 710.6,437.2 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_45': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="1010.1,189.9 718.9,324.7 875.3,481.1 "/>
						<polygon points="928.1,271.9 636.9,406.7 793.3,563.1 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_90': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="1180,600 878.8,489.4 878.8,710.6 "/>
						<polygon points="1064,600 762.8,489.4 762.8,710.6 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_135': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="1010.1,1010.1 875.3,718.9 718.9,875.3 "/>
						<polygon points="928.1,928.1 793.3,636.9 636.9,793.3 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_180': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="599.4,1180 710,878.8 488.8,878.8 "/>
						<polygon points="599.4,1064 710,762.8 488.8,762.8 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_225': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="189.5,1009.7 480.6,874.9 324.2,718.5 "/>
						<polygon points="271.5,927.7 562.7,792.9 406.3,636.5 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_270': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="20,600.2 321.2,710.8 321.2,489.6 "/>
						<polygon points="136,600.2 437.2,710.8 437.2,489.6 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_315': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="189.7,190 324.5,481.2 480.9,324.8 "/>
						<polygon points="271.8,272 406.5,563.2 562.9,406.8 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'you_are_here_270': {
				svgInner = (
					<g>
						{yahCircles}
						<polygon style={color2} points="20,600.2 321.2,710.8 321.2,489.6 "/>
						<polygon points="136,600.2 437.2,710.8 437.2,489.6 "/>
						{yahText}
					</g>
				) 
				break;
			}
			case 'stroller': {
				style = {
					...style,
					enablebackground: 'new 0 0 792 792'
				}
				viewbox = '0 0 792 792'
				svgInner = (
					<g>
						<path d="M629.8,137.3c-24.9,24.8-55.9,57.3-78.8,83.9c-6.4,7.5-8.9,19.6-10.3,30c-8.6,62.5-17.8,124.9-23.9,187.6
							c-8.3,85.2-70.7,122.1-135.8,121c-49.9-0.9-96.2-0.7-153.8-0.7c-2.9,0.1-10.4,1.5-13.1,3.8l-24.4-3.5c0-9.2,2.5-17.6,8.3-30.5
							c6.7-15,19.1-28,30.7-40.3c115.6-123,248.9-265.4,365.8-387.2c24-25,66-17,88,4c20.1,19.2,25,52.5,8.3,73.1
							c-8,9.9-20.6,23.9-29.7,31.9c-11.8,10.3-24.7,8.6-34.9-1.8c-6.4-6.5-8.7-19.9,1-32.1c6.6-8.3,14-16.6,21.4-24.8
							c3.4-3.7,2.4-12.2-1.5-15.3C642.9,132.9,634.2,133,629.8,137.3z"/>
						<path d="M282.3,396c-33.5,35.6-62,66.9-91.7,97c-19.2,19.5-41.9,20.4-57.4,4.4c-14.5-14.9-13.9-36.3,3-55.3
							c17.7-19.9,36.4-38.9,55.1-58c29.3-29.9,41.6-30,73-1.5C268.8,386.7,274,389.9,282.3,396z"/>
						<path d="M586.3,646.7c0,48.2-39,87.2-87.2,87.2s-87.2-39-87.2-87.2s39-87.2,87.2-87.2S586.3,598.5,586.3,646.7z M499.8,610.2
							c-20.4,0-36.9,16.5-36.9,36.9s16.5,36.9,36.9,36.9c20.4,0,36.9-16.5,36.9-36.9S520.2,610.2,499.8,610.2z"/>
						<path d="M276.9,646.7c0,48.2-39,87.2-87.2,87.2s-87.2-39-87.2-87.2s39-87.2,87.2-87.2S276.9,598.5,276.9,646.7z M190.5,610.2
							c-20.4,0-36.9,16.5-36.9,36.9s16.5,36.9,36.9,36.9s36.9-16.5,36.9-36.9S210.8,610.2,190.5,610.2z"/>
						<path d="M474,194l-73,73c-40.3,0-73-32.7-73-73s32.7-73,73-73S474,153.7,474,194z"/>
					</g>
				)
				break;
			}
			case 'wheelchair': {
				svgInner = (
					<g>
						<path d="M1043.7,544.2c-14.2-14.6-34.1-22.3-54.4-21.2l-245.9,13.7l135.3-154.1c19.3-22,24.8-51.2,17.3-77.4
							c-3.9-17.9-14.8-34.2-31.5-44.6C864,260.2,541,72.6,541,72.6c-26.4-15.3-59.6-11.9-82.4,8.4L300.9,221.6
							c-29.1,25.9-31.6,70.5-5.7,99.6s70.5,31.6,99.6,5.7l119.6-106.7l98.9,57.4L438.8,476.4c-72.4,11.8-137.5,45.2-188.6,93.2l91.2,91.2
							c41.2-37.5,95.9-60.3,155.9-60.3c127.9,0,231.9,104,231.9,231.9c0,60-22.9,114.7-60.3,155.9l91.1,91.2c60.7-64.5,98-151.4,98-247
							c0-57-13.2-110.8-36.7-158.7l95.2-5.3l-23.2,284c-3.2,38.8,25.7,72.9,64.6,76c1.9,0.2,3.9,0.2,5.8,0.2c36.4,0,67.2-27.9,70.2-64.8
							l29.7-364.7C1065.2,578.8,1057.9,558.8,1043.7,544.2z"/>
						<path d="M913.1,242c65.2,0,118.1-52.9,118.1-118.1S978.3,5.8,913.1,5.8C847.9,5.9,795,58.8,795,124S847.9,242,913.1,242z"/>
						<path d="M497.2,1064.3c-127.9,0-231.9-104-231.9-231.9c0-48.2,14.8-93,40-130.1l-92.1-92.1c-48,61.3-76.7,138.4-76.7,222.2
							c0,199.2,161.5,360.7,360.7,360.7c83.9,0,161-28.7,222.2-76.7l-92.1-92.1C590.2,1049.5,545.4,1064.3,497.2,1064.3z"/>
					</g>
				)
				break;
			}
			default:
				// broken link icon
				svgInner = (
					<g>
						<path d="M560.4,459.6l68.4,68.4l14.4-14.4h0c22.4-22.5,34.9-52.9,34.9-84.6s-12.5-62.1-34.9-84.6L462,160.8
							c-22.5-22.4-52.9-34.9-84.6-34.9c-31.7,0-62.1,12.5-84.6,34.9l-132,132c-22.4,22.5-34.9,52.9-34.9,84.6c0,31.7,12.5,62.1,34.9,84.6
							L342,643.2c22.5,22.4,52.9,34.9,84.6,34.9c31.7,0,62.1-12.5,84.6-34.9l14.4-14.4l-68.4-68.4L444,576c-4.5,4.4-10.5,6.9-16.8,6.9
							s-12.3-2.5-16.8-6.9L229.2,394.8c-4.4-4.5-6.9-10.5-6.9-16.8s2.5-12.3,6.9-16.8l132-132c4.5-4.4,10.5-6.9,16.8-6.9
							s12.3,2.5,16.8,6.9L576,410.4c4.4,4.5,6.9,10.5,6.9,16.8s-2.5,12.3-6.9,16.8L560.4,459.6z"/>
						<path d="M858,556.8c-22.5-22.4-52.9-34.9-84.6-34.9c-31.7,0-62.1,12.5-84.6,34.9l-14.4,14.4l68.4,68.4L756,624
							c4.5-4.4,10.5-6.9,16.8-6.9s12.3,2.5,16.8,6.9l181.2,181.2c4.4,4.5,6.9,10.5,6.9,16.8s-2.5,12.3-6.9,16.8l-132,132
							c-4.5,4.4-10.5,6.9-16.8,6.9s-12.3-2.5-16.8-6.9L624,789.6c-4.4-4.5-6.9-10.5-6.9-16.8s2.5-12.3,6.9-16.8l14.4-14.4L570,673.2
							l-14.4,14.4c-22.4,22.5-34.9,52.9-34.9,84.6s12.5,62.1,34.9,84.6L738,1039.2c22.5,22.4,52.9,34.9,84.6,34.9
							c31.7,0,62.1-12.5,84.6-34.9l132-132c22.4-22.5,34.9-52.9,34.9-84.6c0-31.7-12.5-62.1-34.9-84.6L858,556.8z"/>
						<path d="M745.5,386.3L922,209.8l67.9,67.9L813.4,454.1L745.5,386.3z"/>
						<path d="M210.3,921.2l176.5-176.5l67.9,67.9L278.2,989L210.3,921.2z"/>
					</g>
				)
		}

		return (
			<svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox={viewbox} style={style} className={`tsicon_${this.props.value}`}>{svgInner}</svg>
		)
	}

	render() {
		return (
			this.icon()
		);
	}
}

export default Icon;
